import { trackSelfDescribingEvent } from "@snowplow/browser-tracker"
import { redirect } from "react-router-dom"

const ORDERED_HOME_ONBOARDING_ROUTES = [
  "startHere",
  "currentSetup",
  "roomFocus",
  "topPriority",
  "whyHomeProfile",
  "biggestPain",
  "updateFrequency",
  "spaceConfidence",
  "mustTrack",
  "shareWithWho",
  "decisionMoment",
  "experimenting",
  "doingGreat",
  "timeSpent",
  "mistakeCost",
  "blocker",
  "futureOutcome",
  "successSignal",
  "commitment",
  "subscriptionCount",
  "almostThere",
]

export default async function navigateToNextHomeOnboardingPageAction({
  request,
}: {
  request: Request
}) {
  const formData = await request.formData()

  trackFormDataWithSnowplow({ formData, url: request.url })

  const next = getNext(request.url)

  if (!next) {
    return redirect("/sign-up/password")
  }

  const nextPathname = getNextPathName({ next, url: request.url })

  return redirect(nextPathname)
}

function getCurrentIndex(url: string): number | undefined {
  const pathname = new URL(url).pathname
  const current = pathname.split("/").pop()

  if (!current) return

  return ORDERED_HOME_ONBOARDING_ROUTES.indexOf(current)
}

function getNext(url: string): string | undefined {
  const currentIndex = getCurrentIndex(url)

  if (currentIndex === undefined) return

  return ORDERED_HOME_ONBOARDING_ROUTES[currentIndex + 1]
}

function getNextPathName({ next, url }: { next: string; url: string }): string {
  const currentPathname = new URL(url).pathname
  const paths = currentPathname.split("/")
  const basePathname = paths.slice(0, -1).join("/")
  const nextPathname = basePathname + "/" + next
  return nextPathname
}

function getStepNumber(currentIndex: number | undefined): number | undefined {
  if (currentIndex === undefined) return undefined
  return currentIndex + 1
}

function trackFormDataWithSnowplow({
  formData,
  url,
}: {
  formData: FormData
  url: string
}) {
  const entries = Array.from(formData.entries())
  const keys = [...new Set(entries.map(([key]) => key))]

  const steps_total = ORDERED_HOME_ONBOARDING_ROUTES.length
  const currentIndex = getCurrentIndex(url)
  const step = getStepNumber(currentIndex)

  for (const key of keys) {
    const data = {
      answers: formData.getAll(key),
      question: key,
      step,
      steps_total,
      url,
    }

    trackSelfDescribingEvent({
      event: {
        data,
        schema: "iglu:com.asanarebel/onboarding_event/jsonschema/1-0-0",
      },
    })
  }
}
